import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Button, Form, Input, InputGroup, Table } from "reactstrap";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { t } from "i18next";

import AgentService from "../../services/agent";

import SortableHeader from "../../components/SortableHeader";
import NoRecords from "../../components/Table/NoRecords";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";

import useListPage from "../../hooks/useListPage";

const HeaderList = [
  {
    title: t("FULL_NAME"),
    value: "fullName",
    style: { minWidth: "150px", width: "30%" },
  },
  {
    title: t("EMAIL_LABEL"),
    value: "mail",
    style: { minWidth: "200px", width: "30%" },
  },
  {
    title: t("MOBILE_NO_LABEL"),
    value: "phoneNumber",
    style: { minWidth: "150px", width: "30%" },
  },
];

function AgentList() {
  const navigate = useNavigate();
  const [setPageTitle, setBreadcrumbItems] = useOutletContext();

  const {
    list,
    isLoading,
    totalCount,
    currentPage,
    itemsPerPage,
    deleteModal,
    debouncedSearch,
    sortBy,
    handlePageClick,
    closeDeleteModal,
    confirmDelete,
  } = useListPage({
    service: AgentService,
    listMethod: "listAgent",
    deleteMethod: "deleteAgent",
    initialSort: null,
    initialPageSize: 10,
    deleteIdField: "id",
  });

  useEffect(() => {
    setPageTitle(t("AGENT.TITLE"));
    setBreadcrumbItems([
      { title: t("APPLICATION_TITLE"), link: "#" },
      { title: t("AGENT.TITLE"), link: "#" },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editFn = (item) => {
    const fullName = `${item.firstName} ${item.lastName}`;
    navigate(`../update/${item.id}`, {
      state: { fullName, companyId: item.companyId },
    });
  };

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Form className="search-filter" onSubmit={(e) => e.preventDefault()}>
          <InputGroup>
            <Input
              onChange={debouncedSearch}
              placeholder={t("SEARCH")}
            />
            <Button color="primary" type="button">
              <i className="ri-search-line"></i>
            </Button>
          </InputGroup>
        </Form>
      </div>

      <Table striped bordered responsive size="sm">
        <thead>
          <tr>
            <SortableHeader
              headers={HeaderList}
              isDisabled={list.length === 0}
              sortClick={sortBy}
            />
          </tr>
        </thead>

        <tbody>
          {list.map((item, l0Idx) => (
            <tr key={l0Idx}>
              <td className="text-center">
                <Button
                  color="primary"
                  size="sm"
                  title={t("AGENT.UPDATE")}
                  onClick={() => editFn(item)}
                >
                  {t("UPDATE_TITLE")}
                </Button>
              </td>
              <td>{item.firstName + " " + item.lastName}</td>
              <td>{item.mail}</td>
              <td>{item.phoneNumber}</td>
            </tr>
          ))}

          {!isLoading && list.length === 0 && (
            <NoRecords colSpan={HeaderList.length + 1} />
          )}
        </tbody>
      </Table>

      <div className="custom-pagination mt-2">
        <PaginationControl
          page={currentPage}
          total={totalCount}
          limit={itemsPerPage}
          changePage={handlePageClick}
          next={true}
          last={true}
          ellipsis={1}
        />
      </div>

      <ConfirmDeleteModal
        isOpen={deleteModal.show}
        isLoading={isLoading}
        confirmFn={confirmDelete}
        cancelFn={closeDeleteModal}
      />
    </React.Fragment>
  );
}

export default AgentList;
